{
  ". Le contenu de la page de destination sera remplacé.": ". Le contenu de la page de destination sera remplacé.",
  "« {{part}} » : plage inversée": "« {{part}} » : plage inversée",
  "« {{part}} » n'est pas valide": "« {{part}} » n'est pas valide",
  "« {{title}} » sera supprimée définitivement.": "« {{title}} » sera supprimée définitivement.",
  "(4 pages supplémentaires = +{{price}}€ par Yearbook)": "(4 pages supplémentaires = +{{price}}€ par Yearbook)",
  "(facultatif)": "(facultatif)",
  "(La modification de l'album remplacera la mise en page actuelle)": "(La modification de l'album remplacera la mise en page actuelle)",
  "(pas floues ou pixellisées)": "(pas floues ou pixellisées)",
  "(vide)": "(vide)",
  "{{count}} élève_one": "{{count}} élève",
  "{{count}} élève_other": "{{count}} élèves",
  "{{count}} étoile_one": "{{count}} étoile_one",
  "{{count}} étoile_other": "{{count}} étoile_other",
  "{{count}} mot non placé : {{words}}_one": "{{count}} mot non placé : {{words}}",
  "{{count}} mot non placé : {{words}}_other": "{{count}} mots non placés : {{words}}",
  "{{count}} mot_one": "{{count}} mot",
  "{{count}} mot_other": "{{count}} mots",
  "{{count}} page nécessaire_one": "{{count}} page nécessaire",
  "{{count}} page nécessaire_other": "{{count}} pages nécessaires",
  "{{count}} page utilisée_one": "{{count}} page utilisée",
  "{{count}} page utilisée_other": "{{count}} pages utilisées",
  "{{count}} page visible_one": "{{count}} page visible",
  "{{count}} page visible_other": "{{count}} pages visibles",
  "{{count}} pages": "{{count}} pages",
  "{{count}} personne par page_one": "{{count}} personne par page",
  "{{count}} personne par page_other": "{{count}} personnes par page",
  "{{count}} photo sélectionnée_one": "{{count}} photo sélectionnée_one",
  "{{count}} photo sélectionnée_other": "{{count}} photo sélectionnée_other",
  "{{count}} photo_one": "{{count}} photo",
  "{{count}} photo_other": "{{count}} photos",
  "{{count}} repère déjà placé_one": "{{count}} repère déjà placé_one",
  "{{count}} repère déjà placé_other": "{{count}} repère déjà placé_other",
  "{{count}} résultat_one": "{{count}} résultat_one",
  "{{count}} résultat_other": "{{count}} résultat_other",
  "{{count}} Yearbook_one": "{{count}} Yearbook",
  "{{count}} Yearbook_other": "{{count}} Yearbooks",
  "{{done}} / {{total}} remarques traitées": "{{done}} / {{total}} remarques traitées",
  "{{first}} ou {{last}} pages": "{{first}} ou {{last}} pages",
  "{{first}} ou {{last}} pages utilisées": "{{first}} ou {{last}} pages utilisées",
  "{{sent}} / {{total}} photos envoyées": "{{sent}} / {{total}} photos envoyées",
  "*La couverture doit mesurer 430×307 mm. En JPG ou PNG avec une résolution de 300 dpi. Il s'agit d'un format A3 paysage avec 5 mm de fond perdu nécessaires pour l'impression.": "*La couverture doit mesurer 430×307 mm. En JPG ou PNG avec une résolution de 300 dpi. Il s'agit d'un format A3 paysage avec 5 mm de fond perdu nécessaires pour l'impression.",
  "*Les images/PDF doivent faire 220x307mm (soit un A4 + 10mm de marge) en résolution 300dpi. Les marges seront coupées à l'impression": "*Les images/PDF doivent faire 220x307mm (soit un A4 + 10mm de marge) en résolution 300dpi. Les marges seront coupées à l'impression",
  "← Revenir à la sélection": "← Revenir à la sélection",
  "+ de couleurs": "+ de couleurs",
  "❤️ Favoris": "❤️ Favoris",
  "⭐ Recommandé": "⭐ Recommandé",
  "💡 Cliquez sur l'emplacement précis de la page où vous souhaitez ajouter votre remarque": "💡 Cliquez sur l'emplacement précis de la page où vous souhaitez ajouter votre remarque",
  "📁 Mes couvertures": "📁 Mes couvertures",
  "📁 Mes fonds": "📁 Mes fonds",
  "📁 Mes modèles": "📁 Mes modèles",
  "📖 Liseuse interactive – Utilisez les flèches ← → ou cliquez pour tourner les pages": "📖 Liseuse interactive – Utilisez les flèches ← → ou cliquez pour tourner les pages",
  "1er de couv": "1er de couv",
  "1ère de couv.": "1ère de couv.",
  "1ère de couverture": "1ère de couverture",
  "2ème de couv": "2ème de couv",
  "2ème de couverture": "2ème de couverture",
  "3ème de couverture": "3ème de couverture",
  "4ème de couv.": "4ème de couv.",
  "4ème de couverture": "4ème de couverture",
  "À faire ({{count}})": "À faire ({{count}})",
  "À l'attention de": "À l'attention de",
  "À l'école": "À l'école",
  "À partir de": "À partir de",
  "À placer": "À placer",
  "À propos de vous": "À propos de vous",
  "Accès enregistrés": "Accès enregistrés",
  "Accès utilisateur": "Accès utilisateur",
  "Adresse de livraison": "Adresse de livraison",
  "Adresse email invalide": "Adresse email invalide",
  "Affichage": "Affichage",
  "Afficher": "Afficher",
  "Afficher le panneau": "Afficher le panneau",
  "Afficher les commentaires ({{count}})": "Afficher les commentaires ({{count}})",
  "Afficher ou masquer le chemin de fer": "Afficher ou masquer le chemin de fer",
  "Afficher uniquement les pages :": "Afficher uniquement les pages :",
  "Afin de toujours mieux vous accompagner, partagez-nous votre expérience": "Afin de toujours mieux vous accompagner, partagez-nous votre expérience",
  "Agrandir le zoom": "Agrandir le zoom",
  "Ajout d'un ou plusieurs fonds de page": "Ajout d'un ou plusieurs fonds de page",
  "Ajout du trombi dans le yearbook": "Ajout du trombi dans le yearbook",
  "Ajouter": "Ajouter",
  "Ajouter au panier": "Ajouter au panier",
  "Ajouter aux favoris": "Ajouter aux favoris",
  "Ajouter des pages": "Ajouter des pages",
  "Ajouter des pages pour aérer mon Yearbook !": "Ajouter des pages pour aérer mon Yearbook !",
  "Ajouter et continuer": "Ajouter et continuer",
  "Ajouter et continuer (Shift+Entrée)": "Ajouter et continuer (Shift+Entrée)",
  "Ajouter et fermer": "Ajouter et fermer",
  "Ajouter et fermer (Entrée)": "Ajouter et fermer (Entrée)",
  "Ajouter ma propre couverture": "Ajouter ma propre couverture",
  "Ajouter un commentaire": "Ajouter un commentaire",
  "Ajouter un fichier": "Ajouter un fichier",
  "Ajouter un mot": "Ajouter un mot",
  "Ajouter un QR Code": "Ajouter un QR Code",
  "Ajouter un repère": "Ajouter un repère",
  "Ajouter un texte": "Ajouter un texte",
  "Ajouter une adresse email…": "Ajouter une adresse email…",
  "Ajouter une classe": "Ajouter une classe",
  "Ajouter une couleur": "Ajouter une couleur",
  "Ajouter une étape": "Ajouter une étape",
  "Ajouter une précision…": "Ajouter une précision…",
  "Ajouter une section": "Ajouter une section",
  "Ajouter vos photos": "Ajouter vos photos",
  "Album": "Album",
  "Album Magique": "Album Magique",
  "Annuler": "Annuler",
  "Annuler (Ctrl+Z)": "Annuler (Ctrl+Z)",
  "Aperçu": "Aperçu",
  "Appliquer": "Appliquer",
  "Appliquer à toutes les pages": "Appliquer à toutes les pages",
  "Après la page": "Après la page",
  "Aucun album ne correspond à « {{query}} »": "Aucun album ne correspond à « {{query}} »",
  "Aucun destinataire disponible.": "Aucun destinataire disponible.",
  "Aucun échange pour le moment.": "Aucun échange pour le moment.",
  "Aucun favori pour le moment.": "Aucun favori pour le moment.",
  "Aucun fond disponible.": "Aucun fond disponible.",
  "Aucun fond personnalisé.": "Aucun fond personnalisé.",
  "Aucun fond recommandé pour le moment.": "Aucun fond recommandé pour le moment.",
  "Aucun historique disponible pour cette page.": "Aucun historique disponible pour cette page.",
  "Aucun modèle de couverture disponible.": "Aucun modèle de couverture disponible.",
  "Aucun modèle disponible pour cette sélection.": "Aucun modèle disponible pour cette sélection.",
  "Aucun modèle disponible.": "Aucun modèle disponible.",
  "Aucun modèle personnel. Créez-en un depuis le menu « ... » d'une page.": "Aucun modèle personnel. Créez-en un depuis le menu « ... » d'une page.",
  "Aucun mot n’a pu être placé.": "Aucun mot n’a pu être placé.",
  "Aucun QR Code disponible.": "Aucun QR Code disponible.",
  "Aucun résultat pour « {{query}} ».": "Aucun résultat pour « {{query}} ».",
  "Aucun sticker disponible.": "Aucun sticker disponible.",
  "Aucun utilisateur": "Aucun utilisateur",
  "Aucune": "Aucune",
  "Aucune classe trouvée.": "Aucune classe trouvée.",
  "Aucune couleur favorite. Ajoutez-en depuis le panneau Texte.": "Aucune couleur favorite. Ajoutez-en depuis le panneau Texte.",
  "Aucune couverture personnalisée.": "Aucune couverture personnalisée.",
  "Aucune grille pour le moment.": "Aucune grille pour le moment.",
  "Aucune page à afficher.": "Aucune page à afficher.",
  "Aucune page générée. Veuillez réessayer.": "Aucune page générée. Veuillez réessayer.",
  "Aucune remarque validée.": "Aucune remarque validée.",
  "Aucune remarque.": "Aucune remarque.",
  "Avant d'ajouter votre Yearbook au panier, vérifiez bien les points suivants :": "Avant d'ajouter votre Yearbook au panier, vérifiez bien les points suivants :",
  "Avant de confirmer l'envoi de votre Yearbook en vérification auprès des graphistes, vérifiez bien les points suivants :": "Avant de confirmer l'envoi de votre Yearbook en vérification auprès des graphistes, vérifiez bien les points suivants :",
  "Avis Google": "Avis Google",
  "Bas": "Bas",
  "Bloquer des pages": "Bloquer des pages",
  "Bouche à oreille": "Bouche à oreille",
  "Carré": "Carré",
  "Cela permettra à nos graphistes de prendre connaissance de vos remarques": "Cela permettra à nos graphistes de prendre connaissance de vos remarques",
  "Cercle": "Cercle",
  "Cette action est définitive et ne peut pas être annulée.": "Cette action est définitive et ne peut pas être annulée.",
  "Cette action est définitive.": "Cette action est définitive.",
  "Cette action est définitive. Le fond sera retiré de vos fonds personnalisés.": "Cette action est définitive. Le fond sera retiré de vos fonds personnalisés.",
  "Cette action est irréversible. La photo sera définitivement supprimée.": "Cette action est irréversible. La photo sera définitivement supprimée.",
  "Cette adresse est déjà ajoutée": "Cette adresse est déjà ajoutée",
  "Chargement de l'album…": "Chargement de l'album…",
  "Chargement de l'historique…": "Chargement de l'historique…",
  "Chargement…": "Chargement…",
  "Chemin de fer": "Chemin de fer",
  "Chez un particulier": "Chez un particulier",
  "Choisir": "Choisir",
  "Choisir un album…": "Choisir un album…",
  "Choisir un dossier": "Choisir un dossier",
  "Choisir un fichier": "Choisir un fichier",
  "Choisir un thème…": "Choisir un thème…",
  "Choisir une couleur": "Choisir une couleur",
  "Choisir une ou plusieurs images": "Choisir une ou plusieurs images",
  "Choisir une photo": "Choisir une photo",
  "Choisissez la page à intervertir avec": "Choisissez la page à intervertir avec",
  "Choisissez la page de destination où dupliquer": "Choisissez la page de destination où dupliquer",
  "Choisissez le format et le nombre de pages souhaités.": "Choisissez le format et le nombre de pages souhaités.",
  "Choisissez un style de remplissage": "Choisissez un style de remplissage",
  "Choisissez une méthode": "Choisissez une méthode",
  "Choisissez une version pour restaurer le contenu de la page.": "Choisissez une version pour restaurer le contenu de la page.",
  "Choix de la page": "Choix de la page",
  "Choix du modèle": "Choix du modèle",
  "Choix du nombre de personnes par page": "Choix du nombre de personnes par page",
  "Choix par nombre de personnes": "Choix par nombre de personnes",
  "Classiques": "Classiques",
  "Client": "Client",
  "Cliquez ensuite sur la photo concernée dans la page": "Cliquez ensuite sur la photo concernée dans la page",
  "Cliquez sur la page pour placer votre commentaire": "Cliquez sur la page pour placer votre commentaire",
  "Cliquez sur la photo pixelisée dans la page": "Cliquez sur la photo pixelisée dans la page",
  "Cliquez sur le bandeau au-dessus d’une page pour lui donner une section.": "Cliquez sur le bandeau au-dessus d’une page pour lui donner une section.",
  "Code postal": "Code postal",
  "Comment avez-vous connu 1Year1Book ?": "Comment avez-vous connu 1Year1Book ?",
  "Commentaire": "Commentaire",
  "Commentaire de {{author}}": "Commentaire de {{author}}",
  "Configurez votre album et laissez la magie opérer !": "Configurez votre album et laissez la magie opérer !",
  "Confirmation de commande": "Confirmation de commande",
  "Correct": "Correct",
  "Couleur de fond": "Couleur de fond",
  "Couleur de la forme": "Couleur de la forme",
  "Couleur du nom": "Couleur du nom",
  "Couleur du sticker": "Couleur du sticker",
  "Couleur du texte": "Couleur du texte",
  "Couleurs": "Couleurs",
  "Couleurs personnalisables": "Couleurs personnalisables",
  "Couv.": "Couv.",
  "Couverture": "Couverture",
  "Couverture envoyée": "Couverture envoyée",
  "Couvertures": "Couvertures",
  "Créatifs": "Créatifs",
  "Création…": "Création…",
  "Créer": "Créer",
  "Créer le modèle": "Créer le modèle",
  "Créer mon album": "Créer mon album",
  "Créer un modèle": "Créer un modèle",
  "Créer un nouveau dossier": "Créer un nouveau dossier",
  "Créez une nouvelle classe pour le trombinoscope.": "Créez une nouvelle classe pour le trombinoscope.",
  "Créez une page unique en un clic grâce à nos modèles et vos photos.": "Créez une page unique en un clic grâce à nos modèles et vos photos.",
  "Créez une règle d'aide à la mise en page. Les éléments s'aimanteront dessus.": "Créez une règle d'aide à la mise en page. Les éléments s'aimanteront dessus.",
  "Dans le livre": "Dans le livre",
  "dans le Yearbook": "dans le Yearbook",
  "de téléphone de la personne qui réceptionnera le(s) colis.": "de téléphone de la personne qui réceptionnera le(s) colis.",
  "Définition / indice": "Définition / indice",
  "Déposez vos photos ici": "Déposez vos photos ici",
  "Description": "Description",
  "Description disponible": "Description disponible",
  "Détail de la remarque…": "Détail de la remarque…",
  "disponible sur la plateforme.": "disponible sur la plateforme.",
  "Distance (mm) — max {{max}}": "Distance (mm) — max {{max}}",
  "Donnez un nom à cette page pour mieux l'identifier": "Donnez un nom à cette page pour mieux l'identifier",
  "Donnez votre note": "Donnez votre note",
  "Dossier de destination": "Dossier de destination",
  "Droite": "Droite",
  "Dupliquer": "Dupliquer",
  "Dupliquer la page": "Dupliquer la page",
  "Dupliquer la page vers…": "Dupliquer la page vers…",
  "Échange": "Échange",
  "Écrivez votre remarque ici...": "Écrivez votre remarque ici...",
  "Éditer": "Éditer",
  "Effacer la recherche": "Effacer la recherche",
  "Élève / Étudiant": "Élève / Étudiant",
  "en quelques clics.": "en quelques clics.",
  "Enlever le fond de page": "Enlever le fond de page",
  "Enlever le trombi du livre": "Enlever le trombi du livre",
  "Enregistrer": "Enregistrer",
  "Envoi en cours...": "Envoi en cours...",
  "Envoi en cours…": "Envoi en cours…",
  "Envoi en vérification": "Envoi en vérification",
  "Envoi…": "Envoi…",
  "Envoyé au client": "Envoyé au client",
  "Envoyé au graphiste": "Envoyé au graphiste",
  "Envoyer": "Envoyer",
  "Envoyer en impression": "Envoyer en impression",
  "Envoyer en vérification": "Envoyer en vérification",
  "Envoyer le livre au graphiste": "Envoyer le livre au graphiste",
  "Envoyer les corrections au client": "Envoyer les corrections au client",
  "Envoyer mes remarques aux graphistes": "Envoyer mes remarques aux graphistes",
  "Envoyer mon avis et lancer l'impression": "Envoyer mon avis et lancer l'impression",
  "Erreur": "Erreur",
  "Erreur {{status}}": "Erreur {{status}}",
  "Erreur lors de l'enregistrement": "Erreur lors de l'enregistrement",
  "Erreur lors de l'envoi": "Erreur lors de l'envoi",
  "Erreur lors du renommage": "Erreur lors du renommage",
  "Erreur réseau": "Erreur réseau",
  "Erreur:": "Erreur:",
  "Est-ce votre premier yearbook avec 1Year1Book ?": "Est-ce votre premier yearbook avec 1Year1Book ?",
  "Établissement": "Établissement",
  "Étape {{step}}/{{total}} — {{title}}": "Étape {{step}}/{{total}} — {{title}}",
  "Ex : CM2 - Mme Dupont": "Ex : CM2 - Mme Dupont",
  "Ex : Mots croisés de la promo": "Ex : Mots croisés de la promo",
  "Expérience 1Year1Book globale": "Expérience 1Year1Book globale",
  "Explorez nos yearbooks pour trouver l'inspiration.": "Explorez nos yearbooks pour trouver l'inspiration.",
  "Favori": "Favori",
  "Félicitations ! Votre yearbook part en impression": "Félicitations ! Votre yearbook part en impression",
  "Félicitations, votre livre est envoyé en vérification chez 1Year1Book.": "Félicitations, votre livre est envoyé en vérification chez 1Year1Book.",
  "Fermer": "Fermer",
  "Fond du bloc": "Fond du bloc",
  "Fonds": "Fonds",
  "Fonds de page": "Fonds de page",
  "Forcer le retour chez 1Y1B": "Forcer le retour chez 1Y1B",
  "Format et taille": "Format et taille",
  "Formes": "Formes",
  "Gauche": "Gauche",
  "Génération en cours…": "Génération en cours…",
  "Générer l'album": "Générer l'album",
  "Générer les modèles": "Générer les modèles",
  "Générer une page": "Générer une page",
  "Générez automatiquement votre album ! Les photos sont placées automatiquement et vous pouvez ensuite les modifier à votre guise.": "Générez automatiquement votre album ! Les photos sont placées automatiquement et vous pouvez ensuite les modifier à votre guise.",
  "Glissez-déposez (png, jpg, jpeg)": "Glissez-déposez (png, jpg, jpeg)",
  "Glissez-déposez vos photos ici": "Glissez-déposez vos photos ici",
  "Grille vide": "Grille vide",
  "Gros texte en haut de la page": "Gros texte en haut de la page",
  "Haut": "Haut",
  "Historique de {{page}}": "Historique de {{page}}",
  "Historique de la page": "Historique de la page",
  "Horizontal": "Horizontal",
  "Import en cours…": "Import en cours…",
  "Importer des photos": "Importer des photos",
  "Importer mes propres fonds ou mes pages perso": "Importer mes propres fonds ou mes pages perso",
  "Impossible d'appliquer le repère à toutes les pages": "Impossible d'appliquer le repère à toutes les pages",
  "Impossible d'enregistrer le commentaire.": "Impossible d'enregistrer le commentaire.",
  "Impossible de charger l'historique": "Impossible de charger l'historique",
  "Impossible de charger les utilisateurs": "Impossible de charger les utilisateurs",
  "Impossible de créer la classe.": "Impossible de créer la classe.",
  "Impossible de sauvegarder les mots croisés": "Impossible de sauvegarder les mots croisés",
  "Imprimer la page": "Imprimer la page",
  "inconnu": "inconnu",
  "Insérer dans la page": "Insérer dans la page",
  "Inspiration": "Inspiration",
  "Internet / Réseaux sociaux": "Internet / Réseaux sociaux",
  "Intervertir": "Intervertir",
  "Intervertir avec une autre page…": "Intervertir avec une autre page…",
  "Intervertir les pages": "Intervertir les pages",
  "J'ai bien vérifié mon fichier": "J'ai bien vérifié mon fichier",
  "Je garde la photo": "Je garde la photo",
  "Je remplace la photo": "Je remplace la photo",
  "Je valide": "Je valide",
  "Je vérifie": "Je vérifie",
  "L'éditeur en ligne et ses outils.": "L'éditeur en ligne et ses outils.",
  "L'impression de vos Yearbooks est lancée": "L'impression de vos Yearbooks est lancée",
  "L'orthographe des textes a bien été vérifiée ?": "L'orthographe des textes a bien été vérifiée ?",
  "La création de l'album remplacera la mise en page actuelle": "La création de l'album remplacera la mise en page actuelle",
  "La création du modèle a échoué. Réessayez.": "La création du modèle a échoué. Réessayez.",
  "La modification n'a pas pu être enregistrée.": "La modification n'a pas pu être enregistrée.",
  "La page {{page}} n'existe pas": "La page {{page}} n'existe pas",
  "Langue": "Langue",
  "Le plus de photos possible": "Le plus de photos possible",
  "Le rendu final de votre livre.": "Le rendu final de votre livre.",
  "Le repère sera ajouté à l'ensemble des pages non verrouillées du livre.": "Le repère sera ajouté à l'ensemble des pages non verrouillées du livre.",
  "Le yearbook a été validé !": "Le yearbook a été validé !",
  "Les autres pages seront masquées pour elle.": "Les autres pages seront masquées pour elle.",
  "Les couleurs de ce fond sont personnalisables": "Les couleurs de ce fond sont personnalisables",
  "Les pages seront bientôt disponibles, Raphaëlle vous envoie très prochainement votre facture mise à jour.": "Les pages seront bientôt disponibles, Raphaëlle vous envoie très prochainement votre facture mise à jour.",
  "Les pages supplémentaires s'ajoutent par 4.": "Les pages supplémentaires s'ajoutent par 4.",
  "Les photos deviendront des emplacements vides. Textes, stickers et formes sont conservés.": "Les photos deviendront des emplacements vides. Textes, stickers et formes sont conservés.",
  "Les Yearbooks seront-ils livrés :": "Les Yearbooks seront-ils livrés :",
  "Lien": "Lien",
  "Ligne": "Ligne",
  "Liseuse": "Liseuse",
  "Livraison offerte dés 50€": "Livraison offerte dés 50€",
  "Livre validé": "Livre validé",
  "Marquer une photo pixelisée": "Marquer une photo pixelisée",
  "Masquer": "Masquer",
  "Masquer le panneau": "Masquer le panneau",
  "Masquer les commentaires ({{count}})": "Masquer les commentaires ({{count}})",
  "Merci": "Merci",
  "Merci de noter les 4 critères ci-dessus": "Merci de noter les 4 critères ci-dessus",
  "Merci de répondre à toutes les questions obligatoires": "Merci de répondre à toutes les questions obligatoires",
  "Merci pour votre avis !": "Merci pour votre avis !",
  "Merci pour votre commande.": "Merci pour votre commande.",
  "Mes couleurs enregistrées": "Mes couleurs enregistrées",
  "Mes couleurs préférées": "Mes couleurs préférées",
  "Mes informations": "Mes informations",
  "Mes photos sont en HD ou à minima de bonnes qualités ?": "Mes photos sont en HD ou à minima de bonnes qualités ?",
  "Message…": "Message…",
  "Mettre le nom ou prénom à la ligne": "Mettre le nom ou prénom à la ligne",
  "Modèle {{current}} / {{total}}": "Modèle {{current}} / {{total}}",
  "Modèles": "Modèles",
  "Modifier": "Modifier",
  "Modifier la grille": "Modifier la grille",
  "Modifier la réponse": "Modifier la réponse",
  "Modifier le format": "Modifier le format",
  "Modifier le format de mon album": "Modifier le format de mon album",
  "Modifier le trombi": "Modifier le trombi",
  "Modifier mon album": "Modifier mon album",
  "Mot": "Mot",
  "Mots & définitions (min. {{min}})": "Mots & définitions (min. {{min}})",
  "Mots croisés": "Mots croisés",
  "Mots non placés": "Mots non placés",
  "🆕 Nouveautés": "🆕 Nouveautés",
  "Nom": "Nom",
  "Nom de l'album": "Nom de l'album",
  "Nom de l'établissement": "Nom de l'établissement",
  "Nom de la classe": "Nom de la classe",
  "Nom de la page": "Nom de la page",
  "Nom du dossier": "Nom du dossier",
  "Nom du modèle": "Nom du modèle",
  "Nom et prénom du destinataire": "Nom et prénom du destinataire",
  "Nom mis à jour": "Nom mis à jour",
  "Nom Prénom": "Nom Prénom",
  "Nombre d'échanges avec les graphistes compris dans votre contrat": "Nombre d'échanges avec les graphistes compris dans votre contrat",
  "Nombre de pages": "Nombre de pages",
  "Non": "Non",
  "Non, on remet ça": "Non, on remet ça",
  "Note…": "Note…",
  "Notre accompagnement": "Notre accompagnement",
  "Nouvelle étape": "Nouvelle étape",
  "Nouvelle grille": "Nouvelle grille",
  "Nouvelle grille de mots croisés": "Nouvelle grille de mots croisés",
  "Nouvelle remarque": "Nouvelle remarque",
  "Nouvelle section": "Nouvelle section",
  "Numéro et rue": "Numéro et rue",
  "Ordre": "Ordre",
  "Organisez vos pages par section et suivez l’avancement.": "Organisez vos pages par section et suivez l’avancement.",
  "Orientation": "Orientation",
  "ou cliquez pour importer depuis votre ordinateur": "ou cliquez pour importer depuis votre ordinateur",
  "ou cliquez pour parcourir votre ordinateur": "ou cliquez pour parcourir votre ordinateur",
  "Oui": "Oui",
  "Oui, c'est une première !": "Oui, c'est une première !",
  "Outils de l’éditeur": "Outils de l’éditeur",
  "Page": "Page",
  "page {{first}} à {{last}}": "page {{first}} à {{last}}",
  "page {{page}}": "page {{page}}",
  "Page magique": "Page magique",
  "page(s)": "page(s)",
  "Pages enregistrées": "Pages enregistrées",
  "Pages visibles par personne, ex.": "Pages visibles par personne, ex.",
  "Par mon école": "Par mon école",
  "Paramètres": "Paramètres",
  "Parcourir l'ensemble des designs disponibles": "Parcourir l'ensemble des designs disponibles",
  "Parent d'élève / Administration": "Parent d'élève / Administration",
  "Pas satisfait": "Pas satisfait",
  "Paysage": "Paysage",
  "Personnaliser le trombi": "Personnaliser le trombi",
  "personne par page_one": "personne par page",
  "personne par page_other": "personnes par page",
  "Personnes autorisées :": "Personnes autorisées :",
  "Peu satisfait": "Peu satisfait",
  "Photos": "Photos",
  "Photos à vérifier": "Photos à vérifier",
  "Pièce jointe": "Pièce jointe",
  "Placé sur la page {{page}}": "Placé sur la page {{page}}",
  "Placé sur les pages {{first}} à {{last}}": "Placé sur les pages {{first}} à {{last}}",
  "Placer « {{name}} »": "Placer « {{name}} »",
  "Placer dans la page": "Placer dans la page",
  "Police": "Police",
  "Portrait": "Portrait",
  "pour": "pour",
  "Prénom": "Prénom",
  "Prénom Nom": "Prénom Nom",
  "Prénom NOM": "Prénom NOM",
  "PRÉNOM NOM": "PRÉNOM NOM",
  "Prêt à envoyer 🚀": "Prêt à envoyer 🚀",
  "Privilégier de grandes photos": "Privilégier de grandes photos",
  "Prix par Yearbook": "Prix par Yearbook",
  "QR Code": "QR Code",
  "Qualité insuffisante": "Qualité insuffisante",
  "Qualité moyenne": "Qualité moyenne",
  "Qualité OK": "Qualité OK",
  "Rechercher un album...": "Rechercher un album...",
  "Rechercher un sticker…": "Rechercher un sticker…",
  "Rechercher une personne…": "Rechercher une personne…",
  "Rectangle": "Rectangle",
  "Réduire le zoom": "Réduire le zoom",
  "Refaire": "Refaire",
  "Refaire (Ctrl+Y)": "Refaire (Ctrl+Y)",
  "Réinitialiser la page": "Réinitialiser la page",
  "Réinitialiser le zoom": "Réinitialiser le zoom",
  "Relecture du YearBook": "Relecture du YearBook",
  "Remarques": "Remarques",
  "Remarques pour les graphistes": "Remarques pour les graphistes",
  "Remplacer la photo": "Remplacer la photo",
  "Renommer l'album": "Renommer l'album",
  "Renommer la page": "Renommer la page",
  "Repasser en à faire": "Repasser en à faire",
  "Repère ajouté": "Repère ajouté",
  "Repère ajouté à toutes les pages": "Repère ajouté à toutes les pages",
  "Répondre": "Répondre",
  "Réponse": "Réponse",
  "Retirer": "Retirer",
  "Retirer de la section": "Retirer de la section",
  "Retirer des favoris": "Retirer des favoris",
  "Retour": "Retour",
  "Retour sur le site": "Retour sur le site",
  "Retour vers le site": "Retour vers le site",
  "Revenir à cette version": "Revenir à cette version",
  "Sans titre": "Sans titre",
  "Satisfaction visuelle du yearbook": "Satisfaction visuelle du yearbook",
  "Satisfait": "Satisfait",
  "Sauvegarde automatique": "Sauvegarde automatique",
  "Sauvegarde en cours…": "Sauvegarde en cours…",
  "Sauvegarde impossible": "Sauvegarde impossible",
  "Section": "Section",
  "Sélectionner le nombre de personnes par page puis le design": "Sélectionner le nombre de personnes par page puis le design",
  "Sélectionnez la photo de remplacement.": "Sélectionnez la photo de remplacement.",
  "Sélectionnez le nombre de pages à ajouter": "Sélectionnez le nombre de pages à ajouter",
  "Seuls les administrateurs peuvent valider ce livre.": "Seuls les administrateurs peuvent valider ce livre.",
  "Soit un total de": "Soit un total de",
  "Sous-titre": "Sous-titre",
  "Spread précédent": "Spread précédent",
  "Spread suivant": "Spread suivant",
  "Stickers": "Stickers",
  "Stickers & Formes": "Stickers & Formes",
  "Style": "Style",
  "Style et disposition": "Style et disposition",
  "Suivant": "Suivant",
  "Suivi client et graphiste.": "Suivi client et graphiste.",
  "Suivi des échanges": "Suivi des échanges",
  "Suppression impossible": "Suppression impossible",
  "Supprimer": "Supprimer",
  "Supprimer ce fond": "Supprimer ce fond",
  "Supprimer ce fond ?": "Supprimer ce fond ?",
  "Supprimer cette couleur": "Supprimer cette couleur",
  "Supprimer cette photo ?": "Supprimer cette photo ?",
  "Supprimer cette remarque ?": "Supprimer cette remarque ?",
  "Supprimer cette section ? Les pages ne sont pas supprimées.": "Supprimer cette section ? Les pages ne sont pas supprimées.",
  "Supprimer la grille ?": "Supprimer la grille ?",
  "Sur quelle page appliquer ce modèle ?": "Sur quelle page appliquer ce modèle ?",
  "Sur quelle page placer le trombinoscope ?": "Sur quelle page placer le trombinoscope ?",
  "Taille": "Taille",
  "Téléphone": "Téléphone",
  "Texte": "Texte",
  "Texte au milieu de la page": "Texte au milieu de la page",
  "Texte italique sous le titre": "Texte italique sous le titre",
  "Thème": "Thème",
  "Titre": "Titre",
  "Titre de la remarque": "Titre de la remarque",
  "Titre ou thème": "Titre ou thème",
  "Tous les élèves sont présent·e·s dans le Trombinoscope ?": "Tous les élèves sont présent·e·s dans le Trombinoscope ?",
  "Tout": "Tout",
  "Tout cocher": "Tout cocher",
  "Tout décocher": "Tout décocher",
  "Tout retirer": "Tout retirer",
  "Toutes les pages": "Toutes les pages",
  "Tranche": "Tranche",
  "Très satisfait": "Très satisfait",
  "Trombi": "Trombi",
  "Trombi complet": "Trombi complet",
  "Trombi simple": "Trombi simple",
  "Trombinoscope": "Trombinoscope",
  "Trombinoscope COMPLET (nom + prénom + citation + photo)": "Trombinoscope COMPLET (nom + prénom + citation + photo)",
  "Trombinoscope SIMPLE (nom + prénom + photo)": "Trombinoscope SIMPLE (nom + prénom + photo)",
  "Type de trombinoscope": "Type de trombinoscope",
  "Un mix de grandes et de petites photos": "Un mix de grandes et de petites photos",
  "Un nouveau tour de relecture sera demandé.": "Un nouveau tour de relecture sera demandé.",
  "Une erreur est survenue lors de l'envoi.": "Une erreur est survenue lors de l'envoi.",
  "Une erreur est survenue.": "Une erreur est survenue.",
  "Une erreur réseau est survenue.": "Une erreur réseau est survenue.",
  "Une suggestion, une amélioration, une fonctionnalité dont vous rêvez…": "Une suggestion, une amélioration, une fonctionnalité dont vous rêvez…",
  "Une version vous sera envoyée pour validation finale.": "Une version vous sera envoyée pour validation finale.",
  "Uploader un couv.": "Uploader un couv.",
  "Uploader une couverture": "Uploader une couverture",
  "Validation du livre avant impression": "Validation du livre avant impression",
  "Validé par l'admin": "Validé par l'admin",
  "Validées ({{count}})": "Validées ({{count}})",
  "Valider": "Valider",
  "Valider la commande": "Valider la commande",
  "Valider le livre": "Valider le livre",
  "Vérification des droits…": "Vérification des droits…",
  "Version {{number}}": "Version {{number}}",
  "Vertical": "Vertical",
  "Veuillez nous communiquer, s'il vous plaît, l'adresse précise de livraison à laquelle": "Veuillez nous communiquer, s'il vous plaît, l'adresse précise de livraison à laquelle",
  "Ville": "Ville",
  "Visible par tous les administrateurs de l'album.": "Visible par tous les administrateurs de l'album.",
  "Voir le suivi des échanges": "Voir le suivi des échanges",
  "Voir les variantes de couleurs": "Voir les variantes de couleurs",
  "Voir plus ({{count}} restantes)": "Voir plus ({{count}} restantes)",
  "Voir tous les modèles": "Voir tous les modèles",
  "Vos idées": "Vos idées",
  "Vos idées nous permettent de toujours mieux vous satisfaire — n'hésitez pas !": "Vos idées nous permettent de toujours mieux vous satisfaire — n'hésitez pas !",
  "Vos retours nous aident à toujours mieux vous accompagner.": "Vos retours nous aident à toujours mieux vous accompagner.",
  "Votre album en 3 clics": "Votre album en 3 clics",
  "Votre commentaire (facultatif)": "Votre commentaire (facultatif)",
  "Votre commentaire…": "Votre commentaire…",
  "Votre livre va être envoyé chez les graphistes 1Year1Book pour vérification.": "Votre livre va être envoyé chez les graphistes 1Year1Book pour vérification.",
  "Votre message…": "Votre message…",
  "Votre plateforme dédiée": "Votre plateforme dédiée",
  "Votre remarque sera envoyée aux graphistes lors de la vérification de votre Yearbook": "Votre remarque sera envoyée aux graphistes lors de la vérification de votre Yearbook",
  "Votre réponse…": "Votre réponse…",
  "Votre ressenti général sur l'aventure.": "Votre ressenti général sur l'aventure.",
  "Votre satisfaction": "Votre satisfaction",
  "Voulez-vous vraiment réinitialiser cette page ? Tous les éléments seront supprimés.": "Voulez-vous vraiment réinitialiser cette page ? Tous les éléments seront supprimés.",
  "Vous êtes :": "Vous êtes :",
  "Vous pouvez aussi nous aider en mettant un avis sur Google et/ou Trustpilot !": "Vous pouvez aussi nous aider en mettant un avis sur Google et/ou Trustpilot !",
  "Vous serez tenu informé par email lorsque la version à valider sera": "Vous serez tenu informé par email lorsque la version à valider sera",
  "vous souhaitez que les yearbooks soient livrés, ainsi que les noms, prénoms et numéros": "vous souhaitez que les yearbooks soient livrés, ainsi que les noms, prénoms et numéros",
  "Vue d'ensemble": "Vue d'ensemble",
  "Zoom arrière": "Zoom arrière",
  "Zoom avant": "Zoom avant"
}